import AssetHelper from "first-common/AssetHelper";
import {initSounds} from "ftc-common/sounds";
import {ScoreCalculator} from "./ScoreCalculator";
import BiobuzzSeason from "./seasons/Biobuzz";
import { createRoot } from "react-dom/client";

AssetHelper.ensureProperties().then(() => {
    initSounds();

    const container = document.getElementById('reactContainer');
    if (container) {
        const root = createRoot(container)
        root.render(<ScoreCalculator season={BiobuzzSeason} />);
    } else {
        console.error("Container element not found")
    }
});